export const makeCRUDQueryKeys = (key: string[]) => {
  const crudKeys = ['all', 'add', 'edit', 'delete'] as const;
  const crudQueryKeys = crudKeys.reduce(
    (acc, cur) => {
      acc[cur] = [...key, cur];
      return acc;
    },
    {} as Record<(typeof crudKeys)[number], readonly string[]>,
  );

  return crudQueryKeys;
};

export const MEMO_FOR_BUSINESS_ENTITY = () => {
  return makeCRUDQueryKeys(['MEMO_FOR_BUSINESS_ENTITY']);
};

export const CASH_FLOW_SETTINGS = () => {
  return makeCRUDQueryKeys(['CASH_FLOW_SETTINGS']);
};
